import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from '../../components/loading/loading.component';
import { Bind } from 'primeng/bind';
import { Accordion, AccordionPanel, AccordionHeader, AccordionContent, AccordionModule } from 'primeng/accordion';
import { Ripple } from 'primeng/ripple';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ApiService } from '../../_utils/api/api.service';
import { InsightService } from '../../_utils/insight/insight.service';
import { SeoService } from '../../_utils/seo/seo.service';

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrl: './info.component.scss',
    imports: [CommonModule, TranslocoDirective, LoadingComponent, Bind, AccordionModule, TranslatePipe]
})
export class InfoComponent {
  loading = signal(false);
  error: string = "";
  data: any = null;
  infos: any[] = [];
  currentLang: string = 'it';

  constructor(private translocoService: TranslocoService, private insightService: InsightService, private seoService: SeoService, private apiService: ApiService, protected router: Router) { }

  ngOnInit(): void {
    this.loading.set(true);
    this.currentLang = this.translocoService.getActiveLang();
    this.translocoService.selectTranslate('main_location').subscribe((main_location) => {
      this.currentLang = this.translocoService.getActiveLang();
      this.apiService.getCompany().subscribe({
        next: (data) => {
          this.loading.set(false);

          const translatePipe = new TranslatePipe(this.translocoService);
          let description = translatePipe.transform(data.data.description);
          this.seoService.setSeo({
            title: data.data.denominazione,
            description: description || data.data.denominazione,
            image: data.data.image || data.data.logo,
            url: data.data.pwa_url + '/info'
          });

          if (typeof window === 'undefined')
            return;

          this.error = "";
          this.data = data.data;
          this.infos = (data.data.infos || []).slice().sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0)); // Ordinamento per order
          
          this.insightService.send({
            event: 'open_page',
            event_name: 'info'
          });
        },
        error: (error) => {
          console.error(error);
          this.router.navigate(['error'], { queryParams: { message: error } });
        }
      });
    });
  }

  /**
   * Get the image path for a file based on its extension
   * @param extension file extension
   * @returns image path
   */
  getFileImage(extension: string): string {
    if (!extension) return '/files/file.png';

    const ext = extension.toLowerCase();
    const fileImages: { [key: string]: string } = {
      'pdf': '/files/pdf-file.png',
      'doc': '/files/doc-file.png',
      'docx': '/files/docx-file.png',
      'xls': '/files/xls-file.png',
      'xlsx': '/files/xls-file.png',
      'jpg': '/files/jpg-file.png',
      'png': '/files/png-file.png',
      'txt': '/files/txt-file.png',
      'svg': '/files/svg-file.png',
    };

    return fileImages[ext] || '/files/file.png';
  }
}
